<template>
    <section class="doc-section">
        <!-- Selector de Plataforma -->
        <div class="mb-6">
            <BotonesNavegacion @cambio-plataforma="plataformaActual = $event" />
        </div>

        <header class="header-container">
            <h1>Búsqueda y Filtrado de Geocercas</h1>
            <p class="intro-text">
                En la vista de geocercas se visualizan todos los registros existentes. El sistema incluye
                un campo <strong>"Buscar"</strong>, diseñado para optimizar la localización de datos
                específicos mediante el filtrado dinámico de la tabla.
            </p>
        </header>

        <div class="instruction-box">
            <div class="step">
                <span class="step-number">1</span>
                <p>Ingrese la palabra o palabras clave en el campo de búsqueda para iniciar el filtrado.</p>
            </div>
            <div class="step">
                <span class="step-number">2</span>
                <p>El sistema actualizará automáticamente la tabla para mostrar únicamente los resultados
                que coincidan con los criterios ingresados.</p>
            </div>
        </div>

        <!-- Sección del Carrusel Dinámico -->
        <div class="carousel-wrapper">
            <transition name="fade" mode="out-in">
                <CarruselAciqui 
                    :key="plataformaActual"
                    :items="imagenesAMostrar" 
                />
            </transition>
        </div>

        <!-- Nota tip -->
        <div class="doc-note note-tip">
            <svg class="note-icon" width="15" height="15" viewBox="0 0 16 16" fill="none">
                <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
                <path d="M8 5v3.5l2 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div class="note-body">
                <span class="note-label">Tip</span>
                <p>El filtrado es en tiempo real: no es necesario presionar Enter ni ningún botón adicional.</p>
            </div>
        </div>

    </section>
</template>

<script setup>
import { ref, computed } from 'vue';
import CarruselAciqui from '../Carruselimg.vue';
import BotonesNavegacion from '../BotonesNavegacion.vue';

const plataformaActual = ref('web');

// Imágenes para versión Web
const imagenesWeb = [
    {
        nombre: "Vista General",
        url: "img/adminGeocercas/Lista de geocercas sin filtrar.png",
        descripcion: "Listado completo de geocercas antes del filtrado."
    },
    {
        nombre: "Resultado de Búsqueda",
        url: "img/adminGeocercas/Lista de geocercas filtradas.png",
        descripcion: "Vista de la tabla tras ingresar palabras clave."
    }
];

// Imágenes para versión Móvil
const imagenesMobile = [
    {
        nombre: "Vista General",
        url: "img/adminGeocercas/VistaGeneral_Movil.png",
        descripcion: "Listado en la app móvil antes de buscar."
    },
    {
        nombre: "Resultado de Búsqueda",
        url: "img/adminGeocercas/ResultadoBusqueda_Movil.png",
        descripcion: "Vista de la tabla en la pantalla del dispositivo."
    }
];

// Lógica de intercambio
const imagenesAMostrar = computed(() => {
    return plataformaActual.value === 'web' ? imagenesWeb : imagenesMobile;
});
</script>

<style scoped>
/* Margen para los botones superiores */
.mb-6 {
    margin-bottom: 1.5rem;
}

/* Transición suave para el cambio de carrusel */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* --- Tus estilos originales --- */
.intro-text {
    margin-top: 16px;
    font-size: 15px;
    opacity: 0.8;
    line-height: 1.6;
}

.instruction-box {
    margin: 24px 0;
    display: flex;
    gap: 16px;
}

.step {
    flex: 1;
    background: var(--code-bg);
    padding: 18px;
    border-radius: 8px;
    border: 1px solid var(--border-color);
    display: flex;
    align-items: center;
    gap: 14px;
}

.step-number {
    background: var(--primary-color);
    color: #ffffff;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 13px;
    font-weight: 700;
    flex-shrink: 0;
}

.step p {
    margin: 0;
    font-size: 14px;
    line-height: 1.6;
}

.carousel-wrapper {
    margin-top: 20px;
    background: var(--code-bg);
    padding: 12px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
}

.carousel-caption {
    text-align: center;
    font-size: 12px;
    opacity: 0.6;
    margin-top: 12px;
    font-style: italic;
}

.doc-note {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 24px;
    padding: 13px 16px;
    border-radius: 6px;
    border: 1px solid;
    font-size: 14px;
}

.note-icon {
    flex-shrink: 0;
    margin-top: 1px;
}

.note-body {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.note-label {
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.note-body p {
    margin: 0;
    line-height: 1.6;
}

.note-tip {
    background: #f0fdf4;
    border-color: #16a34a;
    color: #16a34a;
}
.note-tip p { color: #14532d; }

@media (max-width: 768px) {
    .instruction-box {
        flex-direction: column;
    }
}
</style>